import { instance as CompanyFactory } from '../../../../factory/company';

const RestrictionsFacade = require('../../../../facade/restrictions/restrictions');
const BaseView = require('../abstract-element-options');

module.exports = BaseView.extend({
  template: require('./template.hbs'),

  initialize: async function (options) {
    this.selection = options.selection;

    const getRestrictions = _.partial(
      RestrictionsFacade.getElementRestrictions,
      this.selection.id
    );

    const basicRestrictions = getRestrictions('basic');
    if (!basicRestrictions[0] || _.isUndefined(basicRestrictions[0].video_replace)) {
      basicRestrictions[0] = RestrictionsFacade.getAllDefaultPermissions();
    }

    const features = await CompanyFactory.getCompanyItems('features');
    const isGranularPermissions = features.template_restrictions?.includes?.('enable_template_granular_permission');
    const canReplace = basicRestrictions[0].video_replace || !isGranularPermissions;

    const { resources, folders } = await this.getAllowedReplacements('Video');

    this.render(canReplace, resources, folders);

    Object.prototype.hasOwnProperty.call(options, 'callback') && options.callback();
  },

  fromFolderResourceToSource: function (resource) {
    if (typeof resource === 'string') {
      return {
        source: resource,
        thumbnail: ''
      };
    }

    return {
      thumbnail: resource.data.thumb,
      source: resource.data.source || resource.data.file
    };
  },

  replaceItem: function (asset) {
    if (!asset.source) {
      return;
    }

    const selectedElement = INKIVE.DesignFacade.getSelectedElements()[0];

    INKIVE.DesignFacade.set(selectedElement.id, {
      source: asset.details?.data?.file || asset.details.data.source,
      thumb_src: asset.details?.data?.selected_thumbnail || asset.source,
      just_added: asset.details,
      keep_box_size: true
    });
  },

  render: function (canReplace, sources, folders) {
    if (canReplace) {
      if (sources || folders) {
        this.$el.html(this.template({}));
        this.initReplacementPanel({
          folders,
          assets: sources
        }, 'video');
      } else {
        this.$el.addClass('show-videos-tab');
      }
    }
  },

  remove: function () {
    this.undelegateEvents();
    this.$el.removeData().unbind();
    Backbone.View.prototype.remove.call(this);
  }
});
